module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "homepage-mypage-community-info-template"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "divided-tabpanels tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "decsList1"
    }
  }, [_c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("커뮤니티 개요")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("커뮤니티 명")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.communityInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("소개글")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.changeDesc),
      expression: "changeDesc",
      modifiers: {
        "trim": true
      }
    }],
    ref: "desc",
    staticClass: "input__textarea input__textarea--thin",
    attrs: {
      "placeholder": "최대 200자까지 입력가능합니다.",
      "readonly": _vm.member.loginid === _vm.currentRepresentation ? false : true,
      "maxlength": "200",
      "title": "최대 200자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.changeDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeDesc = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("회원수")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.changeMemberCount),
      expression: "changeMemberCount",
      modifiers: {
        "trim": true
      }
    }],
    ref: "changeMemberCount",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "숫자로만 입력해주세요. 예) 10명 일경우 10",
      "readonly": _vm.member.loginid === _vm.currentRepresentation ? false : true,
      "title": "숫자로만 입력해주세요. 예) 10명 일경우 10"
    },
    domProps: {
      "value": (_vm.changeMemberCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeMemberCount = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("커뮤니티 권한")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.communityInfo.communityPlus ? '커뮤니티 플러스' : '일반'))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("대표이미지")]), _vm._v(" "), _c('p', {
    staticClass: "guide-text"
  }, [_vm._v("277 * 208 px에 최적화 되어 있습니다.")]), _vm._v(" "), (_vm.member.loginid === _vm.currentRepresentation) ? _c('input', {
    ref: "changeImgUrl",
    staticClass: "inline-input__file",
    attrs: {
      "type": "file",
      "id": "changeImgUrl",
      "accept": "image/gif, image/jpeg, image/png",
      "title": "changeImgUrl 첨부파일 선택"
    },
    on: {
      "change": function($event) {
        return _vm.imgUrlChange('changeImgUrl')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thumbnail-img-ex"
  }, [(_vm.communityInfo.imgUrl) ? _c('div', {
    staticClass: "embed-responsive embed-responsive-4by3 background-image",
    style: (("background-image: url('" + (_vm.communityInfo.imgUrl) + "');"))
  }) : _c('div', {
    staticClass: "embed-responsive embed-responsive-4by3 background-image",
    style: ("background-image: url('/images/img/communityDefault.jpg');")
  })])])]), _vm._v(" "), (_vm.communityInfo.applicant) ? _c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("커뮤니티신청자")]), _vm._v(" "), _c('div', {
    staticClass: "form-box-gray"
  }, [_c('div', {
    staticClass: "inline-readonly-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("이름")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.communityInfo.applicant.name))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-readonly-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("생년월일")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.communityInfo.applicant.birthdate))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-readonly-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("연락처")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.communityInfo.applicant.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-readonly-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("이메일")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.communityInfo.applicant.email))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-readonly-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("주소")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.communityInfo.applicant.addrCity) + " " + _vm._s(_vm.communityInfo.applicant.addrGu))])])])]) : _vm._e(), _vm._v(" "), _c('div', {}, [((_vm.member.loginid === _vm.currentRepresentation)) ? _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeApply
    }
  }, [_vm._v("승인요청하기")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "decsList2"
    }
  }, [_c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("커뮤니티 한마디")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group-with-btn clearfix"
  }, [_c('div', {
    staticClass: "grid-3 p-r-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentsWriter),
      expression: "commentsWriter",
      modifiers: {
        "trim": true
      }
    }],
    ref: "commentsWriter",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "입력해주세요.",
      "title": "입력해주세요."
    },
    domProps: {
      "value": (_vm.commentsWriter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentsWriter = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid-33"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentsInput),
      expression: "commentsInput",
      modifiers: {
        "trim": true
      }
    }],
    ref: "commentsInput",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "입력해주세요.",
      "title": "입력해주세요."
    },
    domProps: {
      "value": (_vm.commentsInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentsInput = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "input-btn btn--gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addComments
    }
  }, [_vm._v("추가")])]), _vm._v(" "), (_vm.communityInfo.comments && _vm.communityInfo.comments.length > 0) ? _c('ul', {
    staticClass: "input-added-list"
  }, _vm._l((_vm.communityInfo.comments), function(comment, idx) {
    return _c('li', [_c('div', {
      staticClass: "result-group-with-btn clearfix"
    }, [_c('div', {
      staticClass: "grid-3"
    }, [_c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(comment.writer))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-33 border-l l-m-p-10"
    }, [_c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(comment.comment))])]), _vm._v(" "), _c('button', {
      staticClass: "input-btn btn--gray",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeComments(idx)
        }
      }
    }, [_vm._v("삭제")])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("배너 등록")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-group-with-btn clearfix"
  }, [_c('div', {
    staticClass: "grid-3"
  }, [_c('input', {
    ref: "bannerImg",
    staticClass: "inline-input__file",
    attrs: {
      "type": "file",
      "id": "bannerImg",
      "accept": "image/gif, image/jpeg, image/png",
      "title": "bannerImg 첨부파일 선택"
    },
    on: {
      "change": function($event) {
        return _vm.imgUrlChange('bannerImg')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid-3 p-r-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.title),
      expression: "title",
      modifiers: {
        "trim": true
      }
    }],
    ref: "title",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "최대 30자까지 입력가능합니다.",
      "title": "최대 30자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.linkUrl),
      expression: "linkUrl",
      modifiers: {
        "trim": true
      }
    }],
    ref: "linkUrl",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "예) http://www.naver.com / 최대 50자까지 입력가능합니다.",
      "title": "예) http://www.naver.com / 최대 50자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.linkUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkUrl = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "input-btn btn--gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addBanner
    }
  }, [_vm._v("추가")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.communityInfo.banners && _vm.communityInfo.banners.length > 0) ? _c('ul', {
    staticClass: "input-added-list"
  }, _vm._l((_vm.communityInfo.banners), function(banner, idx) {
    return _c('li', [_c('div', {
      staticClass: "result-group-with-btn clearfix"
    }, [_c('div', {
      staticClass: "grid-3"
    }, [_c('div', {
      staticClass: "preview-img-wrapper"
    }, [_c('img', {
      attrs: {
        "src": banner.imageUrl,
        "alt": "배너이미지"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-3 border-l l-m-p-10"
    }, [_c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(banner.title))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-3"
    }, [_c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(banner.linkUrl))])]), _vm._v(" "), _c('button', {
      staticClass: "input-btn btn--gray",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeBanner(idx)
        }
      }
    }, [_vm._v("삭제")])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("커뮤니티 연락처")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("이메일")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.communityInfo.email),
      expression: "communityInfo.email",
      modifiers: {
        "trim": true
      }
    }],
    ref: "email",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "입력해주세요.",
      "title": "입력해주세요."
    },
    domProps: {
      "value": (_vm.communityInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.communityInfo, "email", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("홈페이지 url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.communityInfo.homepageUrl),
      expression: "communityInfo.homepageUrl",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "http://www.naver.com",
      "title": "http://www.naver.com"
    },
    domProps: {
      "value": (_vm.communityInfo.homepageUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.communityInfo, "homepageUrl", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("sns url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.communityInfo.snsUrl),
      expression: "communityInfo.snsUrl",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "http://facebook.com",
      "title": "http://facebook.com"
    },
    domProps: {
      "value": (_vm.communityInfo.snsUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.communityInfo, "snsUrl", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modifyInfo
    }
  }, [_vm._v("수정하기")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "decsList4"
    }
  }, [((_vm.member.loginid !== _vm.currentRepresentation)) ? _c('h4', {
    staticClass: "margin-bottom-40"
  }, [_vm._v("커뮤니티 대표만 이용 가능한 메뉴입니다.")]) : _vm._e(), _vm._v(" "), ((_vm.member.loginid === _vm.currentRepresentation)) ? _c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('label', {
    staticClass: "lg-label"
  }, [_vm._v("커뮤니티 운영자")]), _vm._v(" "), ((_vm.member.loginid === _vm.currentRepresentation)) ? _c('div', {
    staticClass: "form-box-gray"
  }, [_c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("이름")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.operator.name),
      expression: "operator.name",
      modifiers: {
        "trim": true
      }
    }],
    ref: "operatorName",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "최대 30자까지 입력가능합니다.",
      "title": "최대 30자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.operator.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operator, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("회원 ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.operator.loginid),
      expression: "operator.loginid",
      modifiers: {
        "trim": true
      }
    }],
    ref: "operatorLoginid",
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "최대 30자까지 입력가능합니다.",
      "title": "최대 30자까지 입력가능합니다."
    },
    domProps: {
      "value": (_vm.operator.loginid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operator, "loginid", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("연락처")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.operator.phone),
      expression: "operator.phone",
      modifiers: {
        "trim": true
      }
    }],
    ref: "operatorPhone",
    staticClass: "input__text",
    attrs: {
      "type": "number",
      "placeholder": "숫자만 입력해주세요.",
      "title": "숫자만 입력해주세요."
    },
    domProps: {
      "value": (_vm.operator.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operator, "phone", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "community-add-btn btn--gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addOperator
    }
  }, [_vm._v("추가")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.communityInfo.operators && _vm.communityInfo.operators.length > 0) && (_vm.member.loginid === _vm.currentRepresentation)) ? _vm._l((_vm.communityInfo.operators), function(operator, idx) {
    return _c('div', {
      staticClass: "lg-label-form-group"
    }, [_c('div', {
      staticClass: "form-box-gray"
    }, [_c('div', {
      staticClass: "inline-input-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("이름")]), _vm._v(" "), _c('input', {
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "입력해주세요.",
        "readonly": "",
        "title": "입력해주세요."
      },
      domProps: {
        "value": operator.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "inline-input-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("회원 ID")]), _vm._v(" "), _c('input', {
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "입력해주세요.",
        "readonly": "",
        "title": "입력해주세요."
      },
      domProps: {
        "value": operator.loginid
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "inline-input-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("연락처")]), _vm._v(" "), _c('input', {
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "입력해주세요.",
        "readonly": "",
        "title": "입력해주세요."
      },
      domProps: {
        "value": operator.phone
      }
    })]), _vm._v(" "), (operator.status.key === 'APPROVAL') ? _c('div', {
      staticClass: "inline-input-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("이메일")]), _vm._v(" "), _c('input', {
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "입력해주세요.",
        "readonly": "",
        "title": "입력해주세요."
      },
      domProps: {
        "value": operator.email
      }
    })]) : _vm._e(), _vm._v(" "), (operator.status.key === 'APPROVAL') ? _c('div', {
      staticClass: "inline-input-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("주소")]), _vm._v(" "), _c('div', {
      staticClass: "f-gutter-10"
    }, [_c('div', {
      staticClass: "f-gutter-10__li grid-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (operator.addrCity),
        expression: "operator.addrCity",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "시",
        "readonly": "",
        "title": "시"
      },
      domProps: {
        "value": (operator.addrCity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(operator, "addrCity", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "f-gutter-10__li grid-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (operator.addrGu),
        expression: "operator.addrGu",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "placeholder": "구",
        "readonly": "",
        "title": "구"
      },
      domProps: {
        "value": (operator.addrGu)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(operator, "addrGu", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "inline-input-group clearfix"
    }, [_c('label', {
      staticClass: "inline-input__label"
    }, [_vm._v("승인")]), _vm._v(" "), _c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(_vm.status[operator.status]))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [((operator.loginid !== _vm.member.loginid) || (_vm.member.loginid === _vm.currentRepresentation)) ? _c('button', {
      staticClass: "community-add-btn btn--gray",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeOperator(idx, operator.id)
        }
      }
    }, [_vm._v("삭제\n              ")]) : _vm._e()])])])
  }) : _vm._e(), _vm._v(" "), ((_vm.member.loginid === _vm.currentRepresentation)) ? _c('div', {
    staticClass: "lg-label-form-group"
  }, [_c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("대표자")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.representation),
      expression: "representation",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "title": " 선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.representation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.administrator), function(admin) {
    return _c('option', {
      domProps: {
        "value": admin.loginid
      }
    }, [_vm._v(_vm._s(admin.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("총무")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.operatorManager),
      expression: "operatorManager",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "title": " 선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operatorManager = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.administrator), function(admin) {
    return _c('option', {
      domProps: {
        "value": admin.loginid
      }
    }, [_vm._v(_vm._s(admin.name))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {}, [((_vm.member.loginid === _vm.currentRepresentation)) ? _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modifyManager
    }
  }, [_vm._v("대표, 총무 변경")]) : _vm._e()])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "divided-tabs tab-count--4 clearfix",
    attrs: {
      "role": "tablist",
      "id": "buttons-tab"
    }
  }, [_c('li', {
    staticClass: "divided-tab active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "divided-tab__link",
    attrs: {
      "href": "#decsList1",
      "aria-controls": "decsList${moduleItemId}-${status.count}",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("\n        커뮤니티 개요"), _c('i', {
    staticClass: "fa fa-caret-down divided-tab__link__arrow"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "divided-tab",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "divided-tab__link",
    attrs: {
      "href": "#decsList2",
      "aria-controls": "decsList${moduleItemId}-${status.count}",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("\n        커뮤니티 정보"), _c('i', {
    staticClass: "fa fa-caret-down divided-tab__link__arrow"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "divided-tab",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "divided-tab__link",
    attrs: {
      "href": "#decsList4",
      "aria-controls": "decsList${moduleItemId}-${status.count}",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("\n        커뮤니티 운영자"), _c('i', {
    staticClass: "fa fa-caret-down divided-tab__link__arrow"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "divided-tab",
    attrs: {
      "role": "presentation"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-group-with-btn clearfix"
  }, [_c('div', {
    staticClass: "grid-3"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("예) 총무 김무자")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-33"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("예) 지치지 않는 열정의 프로펠러")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-group-with-btn clearfix"
  }, [_c('div', {
    staticClass: "grid-3"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("예) 총무 김무자")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-3"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("예) 꽃동네 봉사활동")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-3"
  }, [_c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v("http://www.naver.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "helper-text xs-text"
  }, [_vm._v("*확장자 jpg, jpeg, png, gif"), _c('br'), _vm._v(" 파일만\u2029올려주세요.(2mb 이하)"), _c('br'), _vm._v("1130*204px")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2443bfca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/community/MypageCommunityInfo.vue
// module id = 1325
// module chunks = 6